import * as FlowReducerSelectors from './flow-reducer';
import * as AnswerReducerSelectors from './answer-reducer';
import * as UserReducerSelectors from './user-reducer';
export default {
  ...FlowReducerSelectors,
  ...AnswerReducerSelectors,
  ...UserReducerSelectors,
};
